import { render, staticRenderFns } from "./info-view.vue?vue&type=template&id=b0cbea66&scoped=true&"
import script from "./info-view.vue?vue&type=script&lang=js&"
export * from "./info-view.vue?vue&type=script&lang=js&"
import style0 from "./info-view.vue?vue&type=style&index=0&id=b0cbea66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0cbea66",
  null
  
)

export default component.exports